/* Hjem-siden i LOS Marine Workspace som stillbilde i heroen: skallet med rail, og «Hva vil du jobbe med i dag, Egil?» med
   det som trenger oppmerksomhet – akkurat slik systemet ser ut når man logger inn. Skalert inn i rammen, uten interaksjon. */
import { useEffect, useRef, useState } from "react";
import { geoFor } from "../Stage";
import { useCountUp } from "../motion";
import { Shell } from "./LosShell";
import { HomeView } from "./LosViews";

export const LosHomeStill = ({ url = "workspace.los-marine.no", caption, testId = "tilbod-hero-still" }) => {
  const ref = useRef(null);
  const [geo, setGeo] = useState({ mode: "full", vw: 1360, s: 0.86 });
  const [active, setActive] = useState(false);
  useEffect(() => {
    const el = ref.current;
    const ro = new ResizeObserver(([e]) => setGeo(geoFor(e.contentRect.width)));
    ro.observe(el);
    const io = new IntersectionObserver((entries) => setActive(entries[entries.length - 1].isIntersecting), { threshold: 0.15 });
    io.observe(el);
    return () => { ro.disconnect(); io.disconnect(); };
  }, []);
  useCountUp(ref, active, { delay: 700 });
  const ih = geo.mode === "narrow" ? 600 : 820;
  return (
    <div className="mb-frame" data-testid={testId} data-view="hjem" data-mode={geo.mode} data-active={active ? "1" : "0"} aria-hidden="true">
      <div className="mb-chrome">
        <span className="mb-dots"><i /><i /><i /></span>
        <span className="mb-url">{url}</span>
        <span className="mb-cap">{caption}</span>
      </div>
      <div ref={ref} className="mb-view pointer-events-none select-none" style={{ height: ih * geo.s }}>
        <div className="mb-scale mb-cine" style={{ transform: `scale(${geo.s})`, width: geo.vw, height: ih }}>
          <Shell mode={geo.mode} active="hjem" title="Hjem" testId="los-home-still" view="hjem">
            <HomeView beat={active ? 1 : 0} mode={geo.mode} />
          </Shell>
        </div>
      </div>
    </div>
  );
};
